class CartDrawer extends HTMLElement {
  constructor() {
    super();
    
    // CART DRAWER DISABLED - Do not initialize any functionality
    console.log('Cart drawer disabled - no functionality will be loaded');
    return;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    // Check if cart drawer should be reopened after page reload
    this.checkReopenDrawer();
  }
  
  checkReopenDrawer() {
    // Wait for page to fully load, then check if we should reopen the cart drawer
    document.addEventListener('DOMContentLoaded', () => {
      if (localStorage.getItem('reopenCartDrawer') === 'true') {
        localStorage.removeItem('reopenCartDrawer'); // Clear the flag
        setTimeout(() => {
          this.open();
        }, 100); // Small delay to ensure everything is loaded
      }
    });
    
    // Also check immediately in case DOMContentLoaded already fired
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      if (localStorage.getItem('reopenCartDrawer') === 'true') {
        localStorage.removeItem('reopenCartDrawer');
        setTimeout(() => {
          this.open();
        }, 100);
      }
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    // Cart drawer disabled - cart icon now links directly to cart page
    // cartLink.setAttribute('role', 'button');
    // cartLink.setAttribute('aria-haspopup', 'dialog');
    // cartLink.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   this.open(cartLink);
    // });
    // cartLink.addEventListener('keydown', (event) => {
    //   if (event.code.toUpperCase() === 'SPACE') {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('classic');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('classic');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    
    // Handle when sections are null (common issue with this theme)
    if (!parsedState.sections) {
      this.updateCartManually();
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
      return;
    }
    
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionKey = section.section || section.id;
      
      if (sectionElement && parsedState.sections && parsedState.sections[sectionKey]) {
        if (section.id === 'cart-icon-bubble') {
          // Cart icon bubble section returns content directly
          sectionElement.innerHTML = parsedState.sections[sectionKey];
        } else {
          const sectionHTML = this.getSectionInnerHTML(parsedState.sections[sectionKey], section.selector);
          if (sectionHTML) {
            sectionElement.innerHTML = sectionHTML;
          }
        }
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  
  updateCartManually() {
    
    // First wait for cart to be updated by fetching cart data, then get fresh sections
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        // Fetch fresh sections with updated cart data
        const iconBubblePromise = fetch(`${window.location.origin}/?section_id=cart-icon-bubble`);
        const cartDrawerPromise = fetch(`${window.location.origin}/?section_id=cart-drawer`);
        
        return Promise.all([iconBubblePromise, cartDrawerPromise]);
      })
      .then(([iconResponse, drawerResponse]) => {
        return Promise.all([iconResponse.text(), drawerResponse.text()]);
      })
      .then(([iconHtml, drawerHtml]) => {
        const parser = new DOMParser();
        
        // Update cart icon bubble with fresh content (includes both quantity and total)
        const currentIconBubble = document.querySelector('#cart-icon-bubble');
        
        if (currentIconBubble) {
          // The cart-icon-bubble section returns the content directly, not wrapped in #cart-icon-bubble
          // So we need to replace the innerHTML of the current #cart-icon-bubble with the fetched content
          currentIconBubble.innerHTML = iconHtml;
        }
        
        // Update cart drawer
        const drawerDoc = parser.parseFromString(drawerHtml, 'text/html');
        const newCartDrawer = drawerDoc.querySelector('.drawer__inner');
        const currentCartDrawer = this.querySelector('.drawer__inner');
        
        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          currentCartDrawer.classList.remove('is-empty');
        }
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

// customElements.define('cart-drawer', CartDrawer); // DISABLED

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }
  
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        // Handle sections update - if sections are null, manually update
        if (!parsedState.sections) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.updateCartManually();
          }
        } else {
          // Normal section updates
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            if (elementToReplace && parsedState.sections && parsedState.sections[section.section]) {
              if (section.id === 'cart-icon-bubble') {
                // Cart icon bubble section returns content directly
                elementToReplace.innerHTML = parsedState.sections[section.section];
              } else {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              }
            }
          });
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.error('CartDrawerItems error:', error);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
}

// customElements.define('cart-drawer-items', CartDrawerItems); // DISABLED
